<template>
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.95776 6.06769C7.61479 6.06769 8.95776 4.72472 8.95776 3.06769C8.95776 1.41066 7.61479 0.067688 5.95776 0.067688C4.30073 0.067688 2.95776 1.41066 2.95776 3.06769C2.95776 4.72472 4.30073 6.06769 5.95776 6.06769ZM8.05776 6.81769H7.66636C7.14604 7.05675 6.56714 7.19269 5.95776 7.19269C5.34839 7.19269 4.77183 7.05675 4.24917 6.81769H3.85776C2.1187 6.81769 0.707764 8.22863 0.707764 9.96769V10.9427C0.707764 11.5638 1.21167 12.0677 1.83276 12.0677H10.0828C10.7039 12.0677 11.2078 11.5638 11.2078 10.9427V9.96769C11.2078 8.22863 9.79683 6.81769 8.05776 6.81769Z" fill="#727CF5"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>